import React from "react";

/**
 * Individual Stat Card Component
 * Displays a statistic with an icon, title, and count
 */

const StatCard = ({ icon: Icon, title, count, iconColor, iconBgColor }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center space-x-4 shadow-sm hover:shadow-md transition-shadow duration-200">
      {/* Circular Icon */}
      <div
        className={`w-10 h-10 rounded-full ${iconBgColor} flex items-center justify-center flex-shrink-0`}
      >
        {Icon && <Icon className={`text-xl ${iconColor}`} />}
      </div>

      {/* Title and Count */}
      <div className="flex flex-col">
        <p className="text-sm text-gray-600 font-medium">{title}</p>
        <p className="text-xl font-bold text-gray-900">{count}</p>
      </div>
    </div>
  );
};

export default StatCard;
